<template>
  <slot :product="product" />
</template>

<script>
import productIdQuery from "@/graphql/queries/ProductId.gql";

export default {
  name: "ProductQueryWrapper",
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  computed: {
    id() {
      if (this.productId.startsWith("gid://")) {
        return this.productId;
      }
      return "gid://shopify/Product/" + this.productId;
    },
  },
  apollo: {
    product: {
      query: productIdQuery,
      variables() {
        return {
          productId: this.id,
        };
      },
    },
  },
};
</script>
